'use strict';

var React = require('react');

var SvgNavigationMajor = function SvgNavigationMajor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M10 0c-5.52 0-10 4.48-10 10s4.48 10 10 10 10-4.48 10-10-4.48-10-10-10zm-5 15 2.27-6.31 4.04 4.04-6.31 2.27zm7.73-3.69-4.04-4.04 6.31-2.27-2.27 6.31z"
  }));
};

exports.SvgNavigationMajor = SvgNavigationMajor;
